import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import ErrorIcon from '@material-ui/icons/Error'
import {
  TRACES_COLORS, TRACES_HEADINGS,
  tracesIssueCopy, tracesIssues, tracesStatus, tracesWarningText,
} from '../../utils/traces'

const ICONS = { rejected: ErrorIcon }

const WarningCardTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[4],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    padding: 0,
    maxWidth: 340,
    fontSize: 12,
    lineHeight: 1.4,
  },
}))(Tooltip)

const warningCardHeader = {
  display: 'flex', alignItems: 'center', gap: 6,
  padding: '8px 12px', fontWeight: 600, fontSize: 13,
}

const styles = {
  list: { margin: 0, padding: '0 12px', listStyle: 'none' },
  item: { padding: '6px 0', borderTop: '1px solid rgba(0,0,0,0.08)' },
  title: { fontWeight: 600 },
}

function TracesTooltipContent({ status, computed, t }) {
  const Icon = ICONS[status]
  const color = TRACES_COLORS[status]
  const issues = tracesIssues(computed)
  return (
    <div>
      <div style={{ ...warningCardHeader, color, borderLeft: `3px solid ${color}` }}>
        <Icon style={{ fontSize: 16 }} />
        {t(TRACES_HEADINGS[status])}
      </div>
      {issues.length > 0 && (
        <ul style={styles.list}>
          {issues.map(issue => {
            const { title, hint } = tracesIssueCopy(issue.code, t)
            return (
              <li key={issue.code} style={styles.item}>
                <div style={styles.title}>{title}</div>
                {hint && <div>{hint}</div>}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

// fontSize matches the sibling overlap icons of the list it is rendered in.
export default function TracesWarning({ computed, t, fontSize = 18, style }) {
  const status = tracesStatus(computed)
  if (!status) return null
  const Icon = ICONS[status]
  return (
    <WarningCardTooltip
      placement="right-start"
      interactive
      title={<TracesTooltipContent status={status} computed={computed} t={t} />}
    >
      <span
        tabIndex={0}
        role="img"
        aria-label={tracesWarningText(computed, t)}
        style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help', ...style }}
      >
        <Icon style={{ color: TRACES_COLORS[status], fontSize }} />
      </span>
    </WarningCardTooltip>
  )
}
